import fetchAx from "@/axios.js";
import { fileAx } from "@/axiosInstance.js";

export default {
  namespaced: true,
  state: {
    search: null,
    customers: [],
    paraBirimleri: [],
    vade: [],
    contacts: [],
    allAdress: [],
    evrak: "",
    teklifList: [],
    hammaddeList: [],
    gk1List: [],
    gk2List: [],
    gk3List: [],
    gk4List: [],
    gk5List: [],
    gk6List: [],
  },
  mutations: {
    setGk6List(state, payload) {
      state.gk6List = payload;
    },
    setGk5List(state, payload) {
      state.gk5List = payload;
    },
    setGk4List(state, payload) {
      state.gk4List = payload;
    },
    setGk3List(state, payload) {
      state.gk3List = payload;
    },
    setGk2List(state, payload) {
      state.gk2List = payload;
    },
    setGk1List(state, payload) {
      state.gk1List = payload;
    },
    setEvrakNo(state, payload) {
      state.evrak = payload;
    },
    setTeklifList(state, payload) {
      state.teklifList = payload;
    },
    setEvrak(state, payload) {
      state.evrak = payload;
    },
    resetCustomers(state, payload) {
      state.customers = [];
    },
    setContacts(state, payload) {
      state.contacts = payload;
    },
    setCustomers(state, payload) {
      state.customers = payload;
    },
    setParaBirimleri(state, payload) {
      state.paraBirimleri = payload;
    },
    setVade(state, payload) {
      state.vade = payload;
    },
    setAllAdress(state, payload) {
      state.allAdress = payload;
    },
    pushCustomer(state, payload) {
      state.customers.push(payload);
    },
    setHammaddeList(state, payload) {
      state.hammaddeList = payload;
    },
    resetAllGkList(state) {
      state.gk1List = [];
      state.gk2List = [];
      state.gk3List = [];
      state.gk4List = [];
      state.gk5List = [];
      state.gk6List = [];
    },
    resetEvrak(state) {
      state.evrak = "";
    },
    setSearch(state, payload) {
      state.search = payload;
    },
  },
  getters: {
    getCustomers(state) {
      return state.customers.map((customer) => {
        return {
          ...customer,
          isSelected: false,
        };
      });
    },
    getParaBirimleri: (state) => state.paraBirimleri,
    getVade: (state) => state.vade,
    getContacts: (state) => state.contacts,
    getAllAdress: (state) => state.allAdress,
    getEvrak: (state) => state.evrak,
    getTeklifList(state) {
      const list = state.teklifList.filter((teklif) => {
        if (state.search && state.search.trim() !== "") {
          return (
            teklif.ACIKLAMA.toLowerCase().includes(
              state.search.trim().toLowerCase()
            ) ||
            teklif.EVRAKNO.toLowerCase().includes(
              state.search.trim().toLowerCase()
            ) ||
            (teklif.CARIAD &&
              teklif.CARIAD.toLowerCase().includes(
                state.search.trim().toLowerCase()
              ))
          );
          // return teklif.ACIKLAMA.toLowerCase().includes(
          //   state.search.trim().toLowerCase()
          // ) ||
          //   teklif.EVRAKNO.toLowerCase().includes(state.search.toLowerCase()) ||
          //   teklif.CARIAD
          //   ? teklif.CARIAD.toLowerCase().includes(state.search.toLowerCase())
          //   : "";
        } else {
          return true;
        }
      });
      return list;
    },
    getHammaddeList: (state) => state.hammaddeList,
    getGk1List: (state) => state.gk1List,
    getGk2List: (state) => state.gk2List,
    getGk3List: (state) => state.gk3List,
    getGk4List: (state) => state.gk4List,
    getGk5List: (state) => state.gk5List,
    getGk6List: (state) => state.gk6List,
  },
  actions: {
    async fetchTeklif({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let kriterler = {
            queryKey: "TeklifToplamaMaliyetlendirmeEvrakListele",
          };
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                commit(
                  "setTeklifList",
                  JSON.parse(response.data.data.dataJson)
                );
                resolve({ status: 200 });
              }
            })
            .catch((error) => {
              reject(error);
              console.error("Error fetching data:", error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async addTeklifStep({ commit }, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "TeklifToplamaMaliyetlendirmeKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then(async (response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve({
                    success: success,
                    data: payload,
                  });
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          console.log(e);
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafında bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
    async addTeklif({ commit }, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "TeklifToplamaMaliyetlendirmeKaydet",
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("Com/RunMacroWithAuth", request)
          .then(async (response) => {
            if (response.status == 200) {
              if (response.data.succeeded == false) {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              } else {
                let success = {
                  color: "success",
                  text: "İşlem Başarılı...",
                  position: "bottom-center",
                };
                commit("setEvrak", JSON.parse(response.data.data).data.trim());
                resolve({
                  success: success,
                  data: payload,
                });
              }
            } else {
              let error = {
                color: "danger",
                title: "Api Hatası",
                text: response.data.message,
                position: "top-center",
              };
              reject(error);
            }
          });
      });
    },
    async paraBirimleriniGetir({ commit }) {
      let kriterler = {
        queryKey: "ParaBirimleriniGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          if (response.status == 200) {
            commit("setParaBirimleri", JSON.parse(response.data.data.dataJson));
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async vadeGetir({ commit }) {
      let kriterler = {
        queryKey: "TeklifToplamaMaliyetlendirmeVadeGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          if (response.status == 200) {
            commit("setVade", JSON.parse(response.data.data.dataJson));
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchCustomerWithCode({ commit }, code) {
      let kriterler = {
        queryKey: "TeklifCarikodAdSource",
        metin1: code,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);

            commit("setCustomers", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async fetchGetCustomers({ commit }, payload) {
      let kriterler = {
        queryKey: "TeklifCarikodAdSource",
        metin1: payload,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          const data = JSON.parse(response.data.data.dataJson);
          commit("setCustomers", data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async addPotentialCustomer({ dispatch, commit }, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "PotansiyelMusteriEkle",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then(async (response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  console.log(JSON.parse(response.data.data).data);
                  payload.KOD = JSON.parse(response.data.data).data.trim();
                  payload.TIP = "Potansiyel";
                  payload.isSelected = true;
                  commit("pushCustomer", payload);
                  resolve({
                    success: success,
                    data: payload,
                  });
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          console.log(e);
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafında bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
    async getContacts({ commit }, payload) {
      var request = {
        queryKey: "GetContactsByCustomer",
        metin1: payload,
      };
      var response = await fetchAx.post(
        "v1/Dynamic/GetQueryReplaceData",
        request
      );
      if (response.status == 200) {
        commit("setContacts", JSON.parse(response.data.data.dataJson));
      }
    },
    async addContact({}, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "KontaktOlustur",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then(async (response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve({
                    success: success,
                    data: JSON.parse(response.data.data).data,
                  });
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
    async addAdress({ dispatch }, payload) {
      const { adres, ad, kod } = payload;
      var jsonmodel = {
        AD: ad,
        CHCODE: kod,
        ADRES_1: adres,
      };
      var jsonconvert = JSON.stringify(jsonmodel);
      var request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "TeklifAdresKartiOlustur",
      };
      await fetchAx
        .post("Com/RunMacroWithAuth", request)
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {});
    },
    async fetchAdress({ commit }, payload) {
      var request = {
        queryKey: "TeklifCarininAdresKartlari",
        metin1: payload,
      };
      var response = await fetchAx.post(
        "v1/Dynamic/GetQueryReplaceData",
        request
      );
      if (response.status == 200) {
        commit("setAllAdress", JSON.parse(response.data.data.dataJson));
      }
    },
    async fetchHammadde({ commit }, payload) {
      let kriterler = {
        queryKey: "TeklifModuluHammaddeSecim0",
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);

            commit("setHammaddeList", data);
            // resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async fetchGk1({ commit }, payload) {
      let kriterler = {
        queryKey: "TeklifModuluHammaddeSecim" + payload.sorgu,
        metin1: payload.evrakNo,
      };
      const gkKeys = ["gk1", "gk2", "gk3", "gk4", "gk5"];
      gkKeys.forEach((key, index) => {
        if (payload[key] || payload[key] == "") {
          kriterler[`metin${index + 2}`] = payload[key];
        }
      });

      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);

            commit("setGk" + payload.sorgu + "List", data);
            resolve("ok");
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async saveHammadde({ commit }, payload) {
      let kriterler = {
        queryKey: "TeklifModuluHammaddeSecimSonuc",
        metin1: payload.type,
        metin2: payload.gk1,
        metin3: payload.gk2,
        metin4: payload.gk3,
        metin5: payload.gk4,
        metin6: payload.gk5,
        metin7: payload.gk6,
      };

      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);

            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    async addHammeddeMacro({ state, commit }, payload) {
      let jsonValue = {
        EVRAKNO: state.evrak,
        satirlar: [...payload.hammadde],
      };
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(jsonValue),
        MacroKey: "TeklifToplamaMaliyetlendirmeHammaddeKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  // commit("setSuccess", success);
                  // response = JSON.parse(
                  //   JSON.parse(response.data.data)
                  //     .data.replace(/\#\#\#/g, '"')
                  //     .replace(/###/g, '""')
                  // );
                  // console.log(response);
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
    async getTeklifHammadde({ state, commit }, payload) {
      return new Promise(async (resolve, reject) => {
        // Burada herhangi bir işlem yapılmaz
        var request = {
          queryKey: "TeklifModuluSecilmisHammaddeler",
          metin1: state.evrak,
        };
        var response = await fetchAx.post(
          "v1/Dynamic/GetQueryReplaceData",
          request
        );
        resolve({ data: JSON.parse(response.data.data.dataJson) });
      });
    },
    async fetchHammaddeEnBoy({ state }) {
      return new Promise(async (resolve, reject) => {
        var request = {
          queryKey: "TeklifToplamaMaliyetlendirmeEnBoy",
          metin1: state.evrak,
        };
        var response = await fetchAx.post(
          "v1/Dynamic/GetQueryReplaceData",
          request
        );
        resolve({ data: JSON.parse(response.data.data.dataJson) });
      });
    },
    async fetchFileInfo({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          var request = {
            queryKey: "TeklifToplamaMaliyetlendirmeDokumanBilgileri",
            metin1: state.evrak,
          };
          var response = await fetchAx.post(
            "v1/Dynamic/GetQueryReplaceData",
            request
          );
          resolve(JSON.parse(response.data.data.dataJson));
        } catch (error) {
          reject();
        }
      });
    },
    async fetchFileUrl({ state, commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          var response = await fileAx.get(
            `files/generate-presigned-url?filePath=${payload}`
          );
          commit("fileUploadStore/setUrl", response.data.url, { root: true });
          resolve(response.data.url);
        } catch (error) {
          reject();
        }
      });
    },
    async deleteEvrak({}, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "EvrakSilTeklifModulu",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then(async (response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve({
                    success: success,
                    data: payload,
                  });
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          console.log(e);
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafında bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
  },
};
